import React, { useEffect, useState } from "react";

const TeamDataColumn = (props) => {

    const [recentHvi, setRecentHvi] = useState(0);
    const [hviDiff, setHviDiff] = useState(0);
    const [diffType, setDiffType] = useState('plus');

    useEffect(() => {

        if ( !props?.hviArray || props?.hviArray?.length < 1 ) return;

        const dataArray = props?.hviArray;

        const lastItem = dataArray.pop();

        if ( lastItem ) setRecentHvi(lastItem);

        if ( props?.hviArray?.length > 1 ) {
            const secondlastItem = dataArray.pop();

            if ( secondlastItem > lastItem ) {
                setDiffType('minus');

            } else {
                setDiffType('plus');
            }

            const diff = parseInt( ((lastItem - secondlastItem)/((lastItem + secondlastItem)/2))*100, 10 );
                
            if (diff) setHviDiff(diff);
        }
    
    
      }, [props.hviArray]);

    return (
        <div className="team-data-column bg-white shadow-sm py-3 px-4 d-flex align-items-center-center border rounded-3 h-100">
            <div className="d-flex align-items-center flex-grow-1">
                <div>
                    <i className={`fa fa-${ props?.icon || "smile-o"} fa-2x`} aria-hidden="true"></i>
                </div>
                <div className="ps-3">
                    <h5 className="mb-0">{props?.title}</h5>
                    <span>{props?.subTitle}</span>
                </div>
            </div>
            
            {props?.hviArray &&
                <div className="d-flex ps-2">
                    <div className="flex-grow-1 pe-2">
                        <div className="d-flex align-items-center">
                            <h3 className="mb-0 text-primary">{recentHvi}</h3>
                            <span className={`text-sy-${diffType === 'plus' ? 'green' : 'red'} ms-2`}>{hviDiff}%</span>
                        </div>
                        <span className="text-sy-gray font-size-medium">Recent</span>
                    </div>
                </div>
            }
        </div>
    )

}

export default TeamDataColumn;